import { render, staticRenderFns } from "./ERegistrationIAmSmartTermAndCondView.vue?vue&type=template&id=316ae27f&scoped=true&"
import script from "./ERegistrationIAmSmartTermAndCondView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationIAmSmartTermAndCondView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316ae27f",
  null
  
)

export default component.exports